import { EnvConfig } from './env-config.interface';

export const Config: EnvConfig = {
  //Hari
  //  BaseEndpoint: 'http://192.168.2.72:9010/',
  //  LoginEndpoint: 'http://192.168.2.72:9010/auth/login',
  //  LogoutEndpoint: 'http://192.168.2.72:9010/',

  // live 
  /* BaseEndpoint: 'https://spark.titan.in/rest/',
   LoginEndpoint: 'https://spark.titan.in/rest/auth/login',
   LogoutEndpoint: 'https://spark.titan.in/rest/'*/



  //Test Server External
  //  BaseEndpoint: 'http://121.242.201.103:1443/DealerDelight_web/DealerPortal_web/WcfDealerPortal.svc',
  //  LoginEndpoint: 'http://121.242.201.103:1443/DealerDelight_web/DealerPortal_web/WcfDealerPortal.svc',
  //  LogoutEndpoint: 'http://121.242.201.103:1443/LoginPage.aspx',

  // Sundar
  //  ImageEndpoint: 'http://192.168.2.61/IBD_DealerPortal_web/',
  // LoginEndpoint: 'http://192.168.2.61/IBD_DealerPortal_web/WcfDealerPortal.svc',
  // BaseEndpoint: 'http://192.168.2.61/IBD_DealerPortal_web/WcfDealerPortal.svc',

  //Rudrappa
  // ImageEndpoint: 'http://192.168.2.43/IBD_DealerPortal_web/',
  // LoginEndpoint: 'http://192.168.2.43/IBD_DealerPortal_web/WcfDealerPortal.svc',
  // BaseEndpoint: 'http://192.168.2.43/IBD_DealerPortal_web/WcfDealerPortal.svc',

//kumar
  ImageEndpoint: 'http://192.168.2.85/IBD_DealerPortal_web/',
  LoginEndpoint: 'http://192.168.2.85/IBD_DealerPortal_web/WcfDealerPortal.svc',
  BaseEndpoint: 'http://192.168.2.85/IBD_DealerPortal_web/WcfDealerPortal.svc',



  // LogoutEndpoint: 'http://192.168.2.61:8090/DealerDelight/LoginPage.aspx',

  //Titan test server
  // BaseEndpoint: 'http://172.25.7.209:1443/DealerDelight_web/DealerPortal_web/WcfDealerPortal.svc',
  // LoginEndpoint: 'http://172.25.7.209:1443/DealerDelight_web/DealerPortal_web/WcfDealerPortal.svc',
  // LogoutEndpoint: 'http://172.25.7.209:1443/',

  // //Titan Production server
  // BaseEndpoint: 'https://connect.titan.in:443/DealerDelight_web/DealerPortal_web/WcfDealerPortal.svc',
  // LoginEndpoint: 'https://connect.titan.in:443/DealerDelight_web/DealerPortal_web/WcfDealerPortal.svc',
  // LogoutEndpoint: 'https://connect.titan.in:443/',


}

